import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducer from "./reducers/reducer";
import { PrismicProvider } from "@prismicio/react";
import { client, isPrismicConfigured } from "./prismic";

import "./styles/index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from './reportWebVitals';

const store = createStore(reducer);

const container = document.getElementById("root");
const root = createRoot(container);

// Conditionally render with PrismicProvider only if Prismic is configured
const AppWrapper = () => {
  if (isPrismicConfigured() && client) {
    return (
      <PrismicProvider client={client}>
        <App />
      </PrismicProvider>
    );
  }
  
  // Fallback without PrismicProvider if not configured
  return <App />;
};

root.render(
  <Provider store={store}>
    <AppWrapper />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

reportWebVitals();

